export default "__VITE_ASSET__BSjc$Glg__"